export enum RequestAccessExtensions {
  REQUEST_NOT_FOUND = 'REQUEST_NOT_FOUND',
}

export const RequestAccessErrors: Record<string, RequestAccessExtensions> = {
  'Access Request Not found': RequestAccessExtensions.REQUEST_NOT_FOUND,
};
